<template>
    <div class="cookies-popup" v-if="is_open">
        <div class="page-inner">
            <div class="box">
                <div class="text">
                    This website uses cookies to ensure you get the best experience.
                </div>
                <div class="link-btn" @click="close"><router-link to="/privacy-policy/">Learn more</router-link></div>
                <div class="close-btn"><span @click="close">Accept and close</span></div>
            </div>
        </div>
    </div>
</template>

<script>
import Link from '@/components/ui/Link.vue';

export default {
    name: 'cookies',
    components: {
        Link,
    },
    data() {
        return {
            is_open: true,
        }
    },
    methods: {
        close() {
            window.localStorage.setItem('hide_cookies', 1);
            this.is_open = false;
        },
    },

}
</script>

<style lang="scss">

    .cookies-popup {
        position: fixed;
        bottom: 5.2rem;
        left: 0;
        z-index: 999;
        padding: var(--padding-75) var(--padding);
        background: var(--grey);
        box-sizing: border-box;
        width: 100%;
        color: var(--black);

        .box {
            display: flex;

            .text {
                flex: 1;
            }

            .link-btn {
                padding: 0 1em 0 0;
            }

            .close-btn {
                text-align: right;
            }
        }

        a,
        span {
            cursor: pointer;
            text-decoration: underline;

            &:hover {
                text-decoration: none;
            }
        }
    }

    @media only screen and (max-width: 767px) {
        .cookies-popup {
            bottom: 0;

            .page-inner {
                padding: 0;
            } 
            
            .box {
                display: block;

                .text {
                    padding: 0 0 3rem;
                }


                .link-btn {
                    padding:  0;
                    display: inline-block;
                }

                .close-btn {
                    display: inline-block;
                    padding-left: 2rem;
                }
            }


        }
    }


</style>
